import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({ onOpenAnamnese }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="navigation-header">
      <a href="/" className="navigation-logo">
        Wellness Impress
      </a>

      {/* Desktop Navigation */}
      <nav className="navigation-menu">
        <button onClick={() => scrollToSection('services')} className="navigation-link">
          Nos Soins
        </button>
        <button onClick={() => scrollToSection('about')} className="navigation-link">
          À Propos
        </button>
        <button onClick={() => scrollToSection('testimonials')} className="navigation-link">
          Avis Clients
        </button>
        <button onClick={() => scrollToSection('contact')} className="navigation-link">
          Contact
        </button>
      </nav>

      <div className="navigation-utilities">
        <button 
          onClick={onOpenAnamnese}
          className="btn-primary"
        >
          Prendre Rendez-vous
        </button>
      </div>

      {/* Mobile Menu Toggle */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollToSection('services')} className="mobile-menu-link">
            Nos Soins
          </button>
          <button onClick={() => scrollToSection('about')} className="mobile-menu-link">
            À Propos
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="mobile-menu-link">
            Avis Clients
          </button>
          <button onClick={() => scrollToSection('contact')} className="mobile-menu-link">
            Contact
          </button>
          <button 
            onClick={onOpenAnamnese}
            className="btn-primary mobile-menu-cta"
          >
            Prendre Rendez-vous
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;